<span>Student Engagement survey 1</span>
{{#with survey}}
  {{#if description}}
    <div class="description">{{description}}</div>
  {{/if}}
  {{#if sections }}
    <div class="sections">
      {{#each sections }}
        {{#if title }}<div class="title">{{ title }}</div>{{/if}}
        {{#if description }}<div class="description">{{ description }}</div>{{/if}}
        {{#if questions }}
          <div class="questions">
            {{#each questions }}
              <div class="question-answer-set">
                {{#if text }}<div class="question {{../../../question_class}}">{{ text }}</div>{{/if}}
                {{#if answers }}
                  <div class="answers">
                    <div class="btn-group" data-toggle="buttons">
                      {{#each answers }}
                        <label class="btn btn-primary answer">
                          <input type="radio" class="answer" value="{{ id }}" data-question-id="{{ ../id }}" data-answer-id="{{ id }}"/>
                          <span class="text">{{ text }}</span>
                        </label>
                      {{/each}}
                    </div>
                  </div>
                {{/if}}
              </div>
            {{/each}}
          </div>
        {{/if}}
      {{/each}}
    </div>
  {{/if}}
{{/with}}
